import React, { useEffect, useState } from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { messagingService } from '../../../services/messaging.service';

const ClientMessagesButton = ({ unreadCount: explicitUnreadCount }) => {
  const { t } = useTranslation();
  const [loadedUnreadCount, setLoadedUnreadCount] = useState(0);
  useEffect(() => {
    if (explicitUnreadCount != null) return;
    let active = true;
    messagingService.listClientConversations().then((response) => {
      if (!active) return;
      const items = Array.isArray(response.data) ? response.data : response.data?.results || [];
      setLoadedUnreadCount(items.reduce((total, item) => total + Number(item.unread_count || 0), 0));
    }).catch(() => {});
    return () => { active = false; };
  }, [explicitUnreadCount]);
  const unreadCount = explicitUnreadCount ?? loadedUnreadCount;
  const label = t('client_messaging.discussions', 'Discussions');
  return (
    <Tooltip title={label}>
      <IconButton component={Link} to="/client/messages" aria-label={label} sx={{ color: 'white' }}>
        <Badge badgeContent={unreadCount} color="error">
          <ChatBubbleOutlineIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default ClientMessagesButton;
